import { Injectable } from '@angular/core';
import { DailyFootfallPrediction } from '../../classes/models/prediction/DailyFootfallPrediction';
import moment from 'moment';
import { Moment } from 'moment';
import { PredictionRotaWeek } from '../../classes/models/PredictionRotaWeek';
import { RotaSummary } from '../../classes/models/rota/RotaSummary';

/**
 * This service combines footfall predictions and rota summaries into {@link PredictionRotaWeek} list.
 */
@Injectable({
  providedIn: 'root'
})
export class DailyPredictionRotaGroupByWeekService {

  /**
   * Adds {@link dailyPredictions} to {@link predictionRotaWeeks} list.
   * @param predictionRotaWeeks combined footfall predictions and rotas list.
   * @param dailyPredictions daily footfall predictions to be added to the list.
   */
  groupPredictions(
    predictionRotaWeeks: PredictionRotaWeek[],
    dailyPredictions: DailyFootfallPrediction[]
  ): PredictionRotaWeek[] {
    dailyPredictions.forEach(dailyPrediction => {
      const date = moment(dailyPrediction.date, 'YYYY-MM-DD');
      const id = this.getId(date);
      const predictionRotaWeek = predictionRotaWeeks.find(obj => obj.id === id);
      if (!predictionRotaWeek) {
        predictionRotaWeeks.push(new PredictionRotaWeek(
          id,
          moment(date).weekday(0).format('YYYY-MM-DD'),
          moment(date).weekday(6).format('YYYY-MM-DD'),
          [dailyPrediction],
          false)
        );
      } else {
        predictionRotaWeek.dailyPredictions.push(dailyPrediction);
      }
    });
    return predictionRotaWeeks
      .sort((first, second) => first.from > second.from ? 1 : -1);
  }

  /**
   * Adds {@link rotaSummaries} to {@link predictionRotaWeeks} list.
   * @param predictionRotaWeeks combined footfall predictions and rotas list.
   * @param rotaSummaries rota summaries to be added to the list.
   */
  groupRotas(predictionRotaWeeks: PredictionRotaWeek[], rotaSummaries: RotaSummary[]): PredictionRotaWeek[] {
    rotaSummaries.forEach(rotaSummary => {
      const date = moment(rotaSummary.date, 'YYYY-MM-DD');
      const id = this.getId(date);
      const predictionRotaWeek = predictionRotaWeeks.find(obj => obj.id === id);
      if (!predictionRotaWeek) {
        predictionRotaWeeks.push(new PredictionRotaWeek(
          id,
          moment(date).weekday(0).format('YYYY-MM-DD'),
          moment(date).weekday(6).format('YYYY-MM-DD'),
          [],
          true)
        );
      } else {
        predictionRotaWeek.rotaExist = true;
      }
    });
    return predictionRotaWeeks
      .sort((first, second) => first.from > second.from ? 1 : -1);
  }

  private getId(date: Moment) {
    return date
      .startOf('isoWeek')
      .format(PredictionRotaWeek.WEEK_FORMAT);
  }
}
